import type { IUserRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import { ChangeMyPassword } from "@domain/schemas/BI";
import { AxiosResponse } from "axios";

@injectable()
export class ChangePassword {
  @inject(TYPES.IUserRepository)
  private _userRepository!: IUserRepository;

  async executeAsync(changeMyPasswordRequest: ChangeMyPassword): Promise<AxiosResponse> {
    console;
    return this._userRepository.changeMyPassword(changeMyPasswordRequest);
  }
}
